import { Component, HostListener, Inject, OnInit, PLATFORM_ID, ViewEncapsulation } from '@angular/core'
import { LayoutService } from '../../../core/services/layout.service'
import { PageService } from '../../../core/services/page.service'
import { ApiService } from '../../../core/services/api.service'
import { ChatState } from '../../../core/services/chat.service'
import { SitePage } from '../../../site-page/site-page'
import { mobileErrorMessage, mobileHyphensComplete, mobileHyphensSetInstead, sendAppLinkSuccessMessage, validateNumber } from '../../../core/helpers/app-link'
import { isPlatformBrowser } from '@angular/common'
import { addFocusOutEventSetInvalid, clickoutCloseInput, removeInvalidOn, setInvalidOn, setMobileAfterChangeAllHyphens } from '../../../core/helpers/fields-utils'
import { ActivatedRoute, Router } from '@angular/router'
import { PageNavigationService } from '../../../core/services/page-navigation.service'
import { ModalStateService } from '../../../core/services/modal-state.service'
import { ModalTypes } from '../../../core/helpers/modal-store'
import { NGXLogger } from 'ngx-logger'
import { SendAppLinkService } from '../../../core/services/send-app-link.service'
import { inputAriaCheckActiveState } from '../../../core/helpers/inputs-helper'
import { SharedDataService } from 'src/app/core/services/shared-data.service'
import { IUserReview } from '../../../interfaces'

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss', '../../../site-page/site-page.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class HomeComponent extends SitePage implements OnInit {
   favIcon?: HTMLLinkElement;
  //favIcon: HTMLLinkElement = document.querySelector('#favIcon');
  constructor(
    private layout: LayoutService,
    private api: ApiService,
    private sendAppLinkService: SendAppLinkService,
    public page: PageService,
    public chatState: ChatState,
    public pageNavigationService: PageNavigationService,
    public modalStateService: ModalStateService,
    public router: Router,
    route: ActivatedRoute,
    public logger: NGXLogger,
    public sharedDataService: SharedDataService,
    @Inject(PLATFORM_ID) private platformId: object
  ) {
    console.log('Route: ' + router.url.startsWith('/hsfs'));
    super(layout, api.getHomePage(), page, chatState, router, route, pageNavigationService, logger)
    this.layout.subscribeToLayoutChanges().subscribe(
      (observerResponse) => {
        this.breakpoints = this.layout.handleLayoutChanges()
        if (this.breakpoints.small || this.breakpoints.extraSmall) {
          //document?.documentElement?.style?.setProperty('--mobilebulletlist', '13px')
          document?.documentElement?.style?.setProperty('--mobilebulletlist', '0.813rem')
        } else if (this.breakpoints.large || this.breakpoints.extraLarge) {
          //document?.documentElement?.style?.setProperty('--mobilebulletlist', '18px')
          document?.documentElement?.style?.setProperty('--mobilebulletlist', '1.375rem')
        }
      },
      (error: any) => {
        console.error(error)
      }
    )
  }
  hooverPopupText = ''
  hooverPopupTextMobile = ''
  showHooverMenu = false
  public activeTemplate: any = ''
  breakpoints = {
    extraSmall: false,
    small: false,
    medium: false,
    large: true,
    extraLarge: true,
  }

  equipmentProviderInActive: boolean;
  reviews: IUserReview[] = [ ];
  offlinewReviews: IUserReview[] = [
    // {
    //   stars: 5,
    //   title: 'Outstanding!',
    //   text: 'Paying for my dental work just got a lot easier. It’s great having one simple payment.',
    //   consumer: 'Ed'
    //   location: 'Houston'
    // },
      {
        "stars": 5,
        "title": "Smooth process...",
        "text": "Smooth process and clear step <br/>by step instructions",
        "consumer": "Kin",
        "location": "Houston"
      },
      {
        "stars": 5,
        "title": "It’s so EASY...",
        "text": "Getting approved took no time at <br/>all. It was so straight forward!",
        "consumer": "Jeffery",
        "location": "Atlanta"
      },
      {
        "stars": 5,
        "title": "They take the time to explain...",
        "text": "They explain everything and help <br/>make you feel comfortable",
        "consumer": "Brenda",
        "location": "Glenside"
      }
   ]

  ngOnInit() {
     if (!isPlatformBrowser(this.platformId)) {
      return;
    }
     this.favIcon = document.querySelector('#favIcon');

    this.equipmentProviderInActive = this.sharedDataService.getPortalType()
    if(this.equipmentProviderInActive){
      this.reviews = this.offlinewReviews;
    }

     if (this.breakpoints.small || this.breakpoints.extraSmall) {
      document?.documentElement?.style?.setProperty('--mobilebulletlist', '0.813rem')
    } else if (this.breakpoints.large || this.breakpoints.extraLarge) {
      document?.documentElement?.style?.setProperty('--mobilebulletlist', '1.375rem')
    }

    setTimeout(() => {
      // client code
      if (isPlatformBrowser(this.platformId)) {
        this.loadTrustpilot()
      }
    }, 300)
    setTimeout(() => {
      if (this.api.modalPopupText) {
        this.hooverPopupText = this.api.modalPopupText
      }
      if (this.api.modalPopupTextMobile) {
        this.hooverPopupTextMobile = this.api.modalPopupTextMobile
      }
      // client code
      if (isPlatformBrowser(this.platformId)) {
        setMobileAfterChangeAllHyphens('appLinkInputMobile')
        addFocusOutEventSetInvalid('appLinkInputMobile', 'home', validateNumber)
      }
    }, 1000)
    // if (isPlatformBrowser(this.platformId)) {
    // }
    const isRestore = this.checkAndRestore()
    if (!isRestore) {
      this.checkAndRestoreExternal()
    }
    this.activeTemplate = this.sharedDataService.getRoute()
    console.log('Active Template: ' + this.activeTemplate)
    this.equipmentProviderInActive = this.sharedDataService.getPortalType()

    switch (this.equipmentProviderInActive) {
      case true:
       this.favIcon.href = this.sharedDataService.assetsCdn('scheinpay-app-icon.png')
       document.getElementsByTagName('title')[0].innerHTML = 'Practice Pay';
        if(window.innerWidth <= 767){
          document?.documentElement?.style?.setProperty('--pagewrapperhome', 'unset!important')
        } else {
          document?.documentElement?.style?.setProperty('--pagewrapperhome', 'unset!important')
        }
       // document?.documentElement?.style?.setProperty('--background-color', '#0072BC')
        break;
      case false:
        this.favIcon.href = this.sharedDataService.assetsCdn('favicon.ico')
        document.getElementsByTagName('title')[0].innerHTML = 'iCreditWorks';
        if(window.innerWidth <= 767){
          document?.documentElement?.style?.setProperty('--pagewrapperhome', '225em')
        } else {
          document?.documentElement?.style?.setProperty('--pagewrapperhome', '191.25em')
        }
        document?.documentElement?.style?.setProperty('--background-color', '#ea731f')
        break;
      default:
        this.favIcon.href = this.sharedDataService.assetsCdn('favicon.ico')
        document.getElementsByTagName('title')[0].innerHTML = 'iCreditWorks';
        if(window.innerWidth <= 767){
          document?.documentElement?.style?.setProperty('--pagewrapperhome', '225em')
        } else {
          document?.documentElement?.style?.setProperty('--pagewrapperhome', '191.25em')
        }
        //document?.documentElement?.style?.setProperty('--background-color', '#ea731f')
        break;
    }
  }

  loadTrustpilot() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    const trustlist1 = document.getElementById('trustlist1')
    if (trustlist1) {
      (window as any).Trustpilot.loadFromElement(trustlist1)
    }
  }
  checkAndRestoreExternal() {
    const extLink = this.modalStateService.getFromLocalStorage('externalLink')
    this.logger.info(extLink)
    if (extLink === 'true') {
      const type = this.modalStateService.getFromLocalStorage('modalType')
      if (type) {
        this.pageNavigationService.modalRestoreExternal = true
        this.toggleOptionsModal()
      }
     }
  }


  checkAndRestore(): boolean {
    const prev = this.pageNavigationService.getPrevState()
    const current = this.pageNavigationService.getCurrentState()
    // our case or restoring
    if (current && current.trigger === 'popstate') {
      const type = this.modalStateService.getFromLocalStorage('modalType')
      const loanInfo = this.modalStateService.getFromLocalStorage('loanInfo')
      this.logger.info(type)
      this.logger.info(loanInfo)
      this.logger.info(this.pageNavigationService.modalRestore)
      this.logger.info(this.pageNavigationService.openNow)
      this.logger.info(this.pageNavigationService.modalRestoreExternal)
      if (type) {
        this.toggleOptionsModal()
      }
      return true
      // switch(type) {
      //   case ModalTypes.mainform:
      //     this.logger.info(ModalTypes.mainform)

      //     break
      // }
    }
    return false
  }
  onInfoIconTrigger(state: boolean, e: any) {
    if (
      ((e.type === 'mouseenter' || e.type === 'mouseleave') &&
        !this.breakpoints.extraSmall) ||
      (e.type === 'click' && this.breakpoints.extraSmall)
    ) {
      this.logger.info('TRIGGER SHOWING!!!')
      this.showHooverMenu = state
    }
  }

  onPopupClosed(event) {
    this.logger.info(this.showHooverMenu)
    this.showHooverMenu = false
  }



  sendAppLinkEvent(event) {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    const targetDivId = 'home'
    const numbr = (document.getElementById('appLinkInputMobile') as any).value
    this.logger.info(numbr)
    this.logger.info(event)
    if (!validateNumber(numbr)) {
      // this.logger.info('send notify')
      // this.notifier.notify('error', mobileErrorMessage)
      setInvalidOn(targetDivId)
      return
    }
    removeInvalidOn(targetDivId)
    this.sendAppLinkService.sendAppLinkWrapper(null, numbr, null)
  }


  onMobileInput(e) {
    mobileHyphensComplete(e, e.target)
  }


  inputItemClick(event: any): void
  {
    inputAriaCheckActiveState(event.currentTarget)
  }




  @HostListener('document:click', ['$event'])
  clickout(event) {
    clickoutCloseInput(event)
  }


}
